export default __webpack_public_path__ + "static/media/slot-banners-ms.63679d0d.webp";